

export const DocumentName = 'api_prioritization';

export const DefaultCollection = 'nykaa-preprod';
